import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";
import { MatIcon, MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { MatButton } from "@angular/material/button";
import { Router } from "@angular/router";
import { injectPortailService } from "../portal.service";

@Component({
  selector: "app-tenzu-front-portal-success",
  imports: [MatIcon, TranslocoDirective, MatButton],
  template: `
    <div class="flex flex-col items-center justify-center gap-4 p-8" *transloco="let t">
      <div class="h-[200px]">
        <mat-icon
          class="icon-full"
          svgIcon="rocket-animated"
          [attr.aria-description]="t('portal.modal.success.image_aria_description')"
        ></mat-icon>
      </div>
      <h1 class="mat-headline-medium text-tertiary text-center">
        {{ t("portal.modal.success.thanks") }}
      </h1>
      <p class="mat-body-medium">
        {{ t("portal.modal.success.explanation") }}
      </p>
      <button mat-flat-button class="primary-button" (click)="close()">{{ t("commons.close") }}</button>
    </div>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PortalSuccessComponent {
  private portalService = injectPortailService();
  iconRegistry = inject(MatIconRegistry);
  sanitizer = inject(DomSanitizer);
  router = inject(Router);
  constructor() {
    this.iconRegistry.addSvgIcon(
      "rocket-animated",
      this.sanitizer.bypassSecurityTrustResourceUrl("tenzu_rocket_animated.svg"),
    );
    this.router.navigate([], { queryParams: { portalPaymentSuccess: null }, queryParamsHandling: "merge" }).then();
  }

  close() {
    this.portalService.closeModal();
  }
}
